import urlRegexSafe from "url-regex-safe";
import { Dispatch, SetStateAction } from "react";

export const formatBytes = (bytes = 0, rounding = 2): string => {
  if (bytes === 0) {
    return "0 Bytes";
  }

  const d = Math.floor(Math.log(bytes) / Math.log(1000));

  return `${parseFloat((bytes / 1000 ** d).toFixed(rounding))} ${
    ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
  }`;
};

export const generateContent = (response: any): string[] =>
  Array.from(
    new Set(
      JSON.stringify({
        ...response.data.data,
        ...(response.data.included ? response.data.included : {}),
      }).match(urlRegexSafe()),
    ),
  ).map((url) => url.split("?")[0].replace("\\", ""));

export const updateStorageSize = (
  setStorageSize: Dispatch<SetStateAction<any>>,
): void => {
  if (navigator.storage && typeof navigator.storage.estimate === "function") {
    navigator.storage.estimate().then((storageEstimate: StorageEstimate) => {
      if (storageEstimate) {
        setStorageSize({
          usage: formatBytes(storageEstimate.usage),
          quota: formatBytes(storageEstimate.quota),
        });
      }
    });
  }
};

export const getAssignmentType = (id: string): string => {
  if (id.includes("district_student_assignments")) {
    return "districtStudentAssignment";
  }
  if (id.includes("student_assignments")) {
    return "studentAssignment";
  }
  return "teacherSectionAssignment";
};
